import OaApiService from './OaApiService';

export default class PropertyAddressService extends OaApiService {
  constructor(apiHandler) {
    super(apiHandler);
    this.getByIdUrl = '/PropertyAddressREST/get-property-address-by-id';
    this.createUrl = '/PropertyAddressREST/add-property-address';
  }
}
